import styled from "styled-components";
import { HeaderContent } from "./LinkDataInterface";
import { IconsLinks } from "./HeaderIcons";
import { DriveSearch } from "./HeaderDriveSearch";

const HeaderStyle = styled.div`
  width: auto;
  min-height: 50px;
  max-height: 30%;
  margin: 2%;
  display: flex;
  flex-direction: row-reverse;
`;

export function Header({ hContent }: { hContent: HeaderContent }) {
  return (
    <HeaderStyle>
      <DataDiv>
        <IconsLinks icons={hContent.quickLinks} />
        <DriveSearch driveSearch={hContent.driveSearch} />
      </DataDiv>
      <Image src={hContent.logo} />
    </HeaderStyle>
  );
}

const Image = styled.img`
  max-height: 100%;
  max-width: 100%;
  margin: 0px;
  padding: 0px;
  margin-right: 2%;
  justify-self: center;
  align-self: center;
`;

const DataDiv = styled.div`
  height: 100%;
  width: 100%;
  min-width: 300px;
  margin: 0px;
  margin-bottom: 2%;
  padding: 0px;
  margin-left: 2%;
  align-content: center;
  display: grid;
  grid-template-rows: 1fr 75px;
`;
